export function replaceLocation(url: string) {
  window.location.replace(url);
}
